<template>
  <div>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>explore</md-icon>
        </div>
        <h4 class="title">Guides</h4>
      </md-card-header>
      <md-card-content>
        <md-toolbar md-elevation="0" class="md-transparent md-dense">
          <div class="md-toolbar-section-start">
            <md-field md-clearable>
              <label>Search guides by name, country or email</label>
              <md-input v-model="search" />
            </md-field>
          </div>
          <div class="md-toolbar-section-end">
            <md-button
              class="md-icon-button md-dense md-primary md-round"
              @click="newGuide"
            >
              <md-icon>add</md-icon>
              <md-tooltip md-direction="top">Add Guide</md-tooltip>
            </md-button>
          </div>
        </md-toolbar>
        <md-table v-model="filteredGuides" @md-selected="viewGuide">
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            md-selectable="single"
          >
            <md-table-cell md-label="Name">
              {{ item.full_name }}
            </md-table-cell>
            <md-table-cell md-label="Country">
              {{ item.country }}
            </md-table-cell>
            <md-table-cell class="text-right">
              <md-button
                class="md-just-icon md-simple md-danger "
                @click.stop="deleteGuide(item)"
              >
                <md-icon>delete</md-icon>
                <md-tooltip md-direction="top">Delete</md-tooltip>
              </md-button>
              <md-button
                class="md-just-icon md-simple md-success"
                @click.stop="viewGuide(item)"
              >
                <md-icon>visibility</md-icon>
                <md-tooltip md-direction="top">View</md-tooltip>
              </md-button>
            </md-table-cell>
          </md-table-row>

          <template v-slot:md-table-empty-state>
            <md-table-empty-state
              :md-label="
                (search || '').trim()
                  ? 'No matching guides'
                  : 'Show me the way...'
              "
              :md-description="
                (search || '').trim()
                  ? 'Try another search or clear the field.'
                  : 'Add a Guide.'
              "
            >
              <md-button class="md-primary md-raised" @click="newGuide"
                >Add Guide</md-button
              >
            </md-table-empty-state>
          </template>
        </md-table>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
export default {
  props: ["guides"],

  data() {
    return { search: "" };
  },

  computed: {
    filteredGuides() {
      const query = (this.search || "").trim().toLocaleLowerCase();
      return (this.guides || []).filter(guide =>
        [guide.full_name, guide.country, guide.email].some(value =>
          String(value || "")
            .toLocaleLowerCase()
            .includes(query)
        )
      );
    }
  },

  methods: {
    newGuide() {
      this.$emit("addGuide");
    },

    viewGuide(guide) {
      this.$emit("viewGuide", guide);
    },

    deleteGuide(guide) {
      this.$emit("deleteGuide", guide);
    }
  },

  watch: {},

  mounted() {}
};
</script>
<style lang="scss" scoped>
.md-switch {
  margin: 0;
}
</style>
